<template>
  <div class="problem-trust v-centerer" @click="$emit('click', $event)">
    <div class="problem-trust__text">
      {{ `${trust.sToFixed(0)}%` }}
    </div>
    <div class="problem-trust__chart">
      <canvas ref="canvas" />
    </div>
  </div>
</template>

<script>
/**
 * Trust indicator for the problem sheet
 *
 * @vue-prop {Number} trust - Percentage (out of 100)
 */

import { Chart } from 'chart.js';
import { SColors } from '@/utils/constants';

export default {

  name: 'ProblemTrust',

  props: {
    trust: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      chart: null,
    };
  },

  watch: {
    trust() {
      this.buildChart();
    },
  },

  mounted() {
    this.buildChart();
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },

  methods: {
    buildChart() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      let color = SColors.blue;
      let colorLight = SColors.blueLight;
      if (this.trust < 65) {
        color = SColors.yellow;
        colorLight = SColors.yellowLight;
      }
      if (this.trust < 40) {
        color = SColors.redBad;
        colorLight = SColors.lightRedBad;
      }

      const config = {
        responsive: false,
        maintainAspectRatio: false,
        type: 'doughnut',
        data: {
          labels: [''],
          datasets: [{
            data: [this.trust, 100 - this.trust],
            backgroundColor: [color, colorLight],
            hoverBackgroundColor: [color, colorLight],
            borderWidth: [0, 0],
            hoverBorderWidth: [0, 0],
          }],
        },
        options: {
          cutout: '65%',
          elements: {
            arc: {
              roundedCornersFor: { start: [0], end: [0] },
            },
          },
        },
      };
      this.chart = new Chart(this.$refs.canvas.getContext('2d'), config);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.problem-trust {
  font-weight: 600;
  cursor: pointer;

  &__chart {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.5rem;
  }
}
</style>
